<div>
  <div class="upload-wizzard" [class]="{ active: dataCatalogStatus?.status == 'PRISTINE' || dataCatalogStatus?.status == 'READY', done: dataCatalogStatus?.status != 'PRISTINE' }">
    <div class="row d-flex align-items-stretch">
      <div class="col-2 d-flex flex-column align-items-center justify-content-center">
        <h1>1</h1>
        <h5>{{ "Template.UploadComponent.subHeader_uploadData" | translate}}</h5>
      </div>
      <div class="col-4 d-flex flex-column justify-content-center" [class]="{ enabled: dataCatalogStatus?.status == 'PRISTINE' || dataCatalogStatus?.status == 'READY' }">
        <input #formFile class="form-control" type="file" id="formFile" accept=".xlsx, .xls, .csv" (change)="onFileSelected($event)" [disabled]="!(dataCatalogStatus?.status == 'PRISTINE' || dataCatalogStatus?.status == 'READY')" />

        <button type="submit" (click)="postFile()" class="btn btn-secondary d-block w-100 mt-2" [disabled]="!file || isButtonDisabled">{{ "Template.FileUploadFormComponent.btn_upload" | translate }}</button>
      </div>
      <div class="col-6 d-flex flex-column justify-content-center">
        <p>{{ "Template.UploadComponent.text_firstStep" | translate}}</p>
      </div>
    </div>
  </div>

  <div class="upload-wizzard" [class]="{ active: dataCatalogStatus?.status == 'UPLOADED' || dataCatalogStatus?.status == 'PROCESSING' || dataCatalogStatus?.status == 'CLEANING', done: dataCatalogStatus?.status == 'READY' }">
    <div class="row d-flex align-items-stretch">
      <div class="col-2 d-flex flex-column align-items-center justify-content-center">
        <h1>2</h1>
        <h5>{{ "Template.UploadComponent.subHeader_dataProcessing" | translate}}</h5>
      </div>
      <div class="col-4 d-flex flex-column justify-content-center">
        <div class="w-100 text-center">
          @if (dataCatalogStatus?.status == 'UPLOADED') {
            <div>
              <fa-icon icon="spinner" animation="spin" size="2x"></fa-icon>
              <small class="d-block mt-2">{{ "Template.UploadComponent.text_importStarting" | translate}} </small>
            </div>
          }

          @if (dataCatalogStatus?.status != 'UPLOADED') {
            <ngb-progressbar [showValue]="true" type="success" [value]="dataCatalogStatus?.progress || 0" [animated]="true"></ngb-progressbar>
          }
        </div>
      </div>
      <div class="col-6 d-flex flex-column justify-content-center">
        <p>{{ "Template.UploadComponent.text_secondStep" | translate}}</p>
      </div>
    </div>
  </div>

  @if (dataCatalogStatus && mediaItemsByStatus) {
    <div class="upload-wizzard" [class]="{ active: dataCatalogStatus.status == 'READY' && (dataCatalogStatus.messages.length || mediaItemsByStatus['NOT_FOUND']?.length || mediaItemsByStatus['INVALID']?.length), done: dataCatalogStatus.status == 'READY' }">
      <div class="row d-flex align-items-stretch">
        <div class="col-2 d-flex flex-column align-items-center justify-content-center">
          <h1>3</h1>
          @if (dataCatalogStatus.status == 'READY') {
            <h5>{{ "Template.UploadComponent.subHeader_ready" | translate}}</h5>
          }
          @if (dataCatalogStatus.status != 'READY') {
            <h5>{{ "Template.UploadComponent.subHeader_response" | translate}}</h5>
          }
        </div>
        @if (dataCatalogStatus?.status == 'READY' && !dataCatalogStatus.messages?.length && !mediaItemsByStatus['NOT_FOUND']?.length && !mediaItemsByStatus['INVALID']?.length) {
          <div class="col-4 d-flex flex-column justify-content-center">
            <fa-icon icon="check" size="3x" class="text-success"></fa-icon>
          </div>
        }
        <div class="d-flex flex-column justify-content-center" [class]="{ 'col-10': dataCatalogStatus.status != 'READY' || (dataCatalogStatus.status == 'READY' && (dataCatalogStatus.messages.length || mediaItemsByStatus['NOT_FOUND']?.length || mediaItemsByStatus['INVALID']?.length)), 'col-6': dataCatalogStatus.status == 'READY' && !dataCatalogStatus.messages.length && !mediaItemsByStatus['NOT_FOUND']?.length && !mediaItemsByStatus['INVALID']?.length }">
          @if (dataCatalogStatus.status != 'READY') {
            <p>{{ "Template.UploadComponent.text_response" | translate}}</p>
          }
          @if (dataCatalogStatus.status == 'READY' && !dataCatalogStatus.messages?.length && !mediaItemsByStatus['NOT_FOUND']?.length && !mediaItemsByStatus['INVALID']?.length) {
            <p>{{ "Template.UploadComponent.text_uploadSuccess" | translate}}</p>
          }
          @if (dataCatalogStatus.status == 'READY' && (dataCatalogStatus.messages?.length || mediaItemsByStatus['NOT_FOUND']?.length || mediaItemsByStatus['INVALID']?.length)) {
            <p>{{ "Template.UploadComponent.text_uploadError" | translate}}</p>
          }
          @if (dataCatalogStatus.status == 'READY' && mediaItemsByStatus['NEW']?.length) {
            <p class="mt-2">
              <fa-icon icon="exclamation-triangle" size="1x" class="text-warning me-2"></fa-icon>
              <strong>{{ "Template.UploadComponent.text_processingContinues1" | translate : { amount: mediaItemsByStatus["NEW"]?.length } }}</strong>
              {{ "Template.UploadComponent.text_processingContinues2" | translate }}
              <fa-icon icon="spinner" animation="spin" size="1x"></fa-icon>
            </p>
          }
          <app-messages-nav [dataCatalogStatus]="dataCatalogStatus" [mediaItemsByStatus]="mediaItemsByStatus"></app-messages-nav>
        </div>
      </div>
    </div>
  }
</div>
